import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { KpisSupplierSalesValueYear } from './KpisSupplierSalesValueYear.entity';

export class KpisSupplier<T extends EMode = EMode.entity> {
  /** Alias: salesValues */
  salesValues?: KpisSupplierSalesValueYear<T>[];
  /** Alias: vacantPositions */
  vacantPositions?: number;
  /** Alias: dueOpenValue */
  dueOpenValue?: number;

  __typename?: string;
}

const fields: FieldDefinitions<KpisSupplier> = {
  salesValues: {
    alias: 'salesValues',
    entity: Entities.kpisSupplierSalesValueYear,
  },
  vacantPositions: {
    alias: 'vacantPositions',
  },
  dueOpenValue: {
    alias: 'dueOpenValue',
  },
  __typename: {
    alias: '__typename',
  },
};

export const kpisSupplierEntityDefinition: EntitiyDefinition<KpisSupplier> = {
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'KpisSupplier',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
